module.exports = __webpack_public_path__ + "static/img/game-series-1-1.02f3721.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/game/game-series-1-1.png
// module id = khvv
// module chunks = 1